import { Component, Input } from '@angular/core';

@Component({
  selector: 's-polaris-progress-bar',
  templateUrl: './s-polaris-progress-bar.component.html',
  styleUrls: ['./s-polaris-progress-bar.component.scss'],
  standalone: false,
})
export class PolarisProgressBarComponent {
  /** Fill amount, 0–100. */
  @Input() progress = 0;
}
